import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs">
    <ol className="flex flex-wrap items-center gap-1 text-sm text-brand-muted">
      <li>
        <Link to="/" data-testid="breadcrumb-home" className="transition-colors hover:text-brand">
          Home
        </Link>
      </li>
      {items.map((item, i) => (
        <li key={i} className="flex items-center gap-1">
          <ChevronRight className="h-3.5 w-3.5" aria-hidden="true" />
          {item.to ? (
            <Link to={item.to} className="transition-colors hover:text-brand">
              {item.label}
            </Link>
          ) : (
            <span aria-current="page" className="font-semibold text-brand">
              {item.label}
            </span>
          )}
        </li>
      ))}
    </ol>
  </nav>
);

export const PageHero = ({ chapter, eyebrow, title, description, crumb }) => (
  <section data-testid="page-hero" className="grid-bg relative overflow-hidden border-b border-brand-line bg-white">
    <div
      className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-brand-light"
      aria-hidden="true"
    />
    <div
      className="pointer-events-none absolute -bottom-32 left-1/3 h-64 w-64 rounded-full bg-amber-50"
      aria-hidden="true"
    />
    <div className="relative mx-auto max-w-7xl px-4 py-14 sm:px-6 sm:py-20">
      <Reveal y={16}>
        <Breadcrumbs items={[{ label: crumb }]} />
      </Reveal>
      <Reveal delay={0.08}>
        <p className="mt-6 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.2em] text-brand-green">
          <span className="h-px w-8 bg-brand-green" aria-hidden="true" />
          {chapter} — {eyebrow}
        </p>
      </Reveal>
      <Reveal delay={0.16}>
        <h1 className="mt-3 max-w-3xl font-display text-4xl font-extrabold tracking-tight text-brand-ink sm:text-5xl">
          {title}
        </h1>
      </Reveal>
      {description && (
        <Reveal delay={0.24}>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-brand-muted sm:text-lg">
            {description}
          </p>
        </Reveal>
      )}
    </div>
  </section>
);
